import { render, staticRenderFns } from "./VatBookings.vue?vue&type=template&id=47a79562"
import script from "./VatBookings.vue?vue&type=script&lang=js"
export * from "./VatBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports